import axios from "axios";
import { parseResponse, parseError } from '../utils/parseResponse';

function normalizeApiBaseUrl(raw) {
    if (typeof raw !== 'string') {
        return '';
    }
    return raw.trim().replace(/\/+$/, '');
}

export const getShowerMeetingDetails = async (meeting_Id) => {
    const baseUrl = normalizeApiBaseUrl(process.env.REACT_APP_API_URL);

    // Without a real absolute base URL, `${undefined}/?cmd=...` becomes the path
    // "undefined/" and resolves relative to the page (e.g. /meeting/undefined/).
    if (!baseUrl) {
        return Promise.resolve(
            parseError({
                response: {
                    status: 400,
                    data: {
                        message:
                            'REACT_APP_API_URL is not set. Add it to .env.local in the project root (see env.example). It must be your backend API origin, not the React app URL.',
                    },
                },
            }),
        );
    }

    return axios({
        url: `${baseUrl}/?cmd=video.getShowerMeetingDetails`,
        method: 'post',
        params: {
            meetingId: meeting_Id,
        },
    })
        .then(parseResponse)
        .catch(parseError);
}
